/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ixj7cv4qtjaeflzkephujivc6y.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-v2f7kqimqjcrthejqrqoobddru",
    "aws_cloud_logic_custom": [
        {
            "name": "slackApi",
            "endpoint": "https://f5b2k0mbof.execute-api.us-east-1.amazonaws.com/ml",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:223892ca-321d-49f6-94f5-6064c63b7830",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_V8nGUhlbY",
    "aws_user_pools_web_client_id": "231062oaso07fgkcu7d84nsgem",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "myconnectupload8df02-ml",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
